import React from "react";
import ManagementLayout from "../layouts/ManagementLayout";

const Management = () => {
  return (
    <div className="p-8 bg-gray-100">
      <ManagementLayout />
    </div>
  );
};

export default Management;
